import React from 'react';

import { COMPONENT_TYPES, TextVariants } from '@life-moments/lifehub-components';

import Variant from '../../components/variant';

import styles from './styles.module.scss';

type Props = {
  variants: TextVariants[];
  content: string;
};

const TextBlockVariants = ({ variants, content }: Props): React.JSX.Element => (
  <div className={styles.list}>
    {variants.map(variant => (
      <Variant key={variant.name} variant={variant} type={COMPONENT_TYPES.text} content={content} />
    ))}
  </div>
);

export default TextBlockVariants;
